import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { http } from "@next-core/http";
/**
 * @description 查询独立部署小产品
 * @endpoint POST /api/v1/micro_app_standalone/search
 */
export var RuntimeApi_searchMicroAppStandalone = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (data, options) {
    return (/**! @contract easyops.api.micro_app_standalone.runtime.SearchMicroAppStandalone@1.0.1 */(yield http.post("api/gateway/micro_app_standalone.runtime.SearchMicroAppStandalone/api/v1/micro_app_standalone/search", data, options)).data
    );
  });
  return function RuntimeApi_searchMicroAppStandalone(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
//# sourceMappingURL=searchMicroAppStandalone.js.map